/* tslint:disable */
/* eslint-disable */
export enum OrderPaymentStatus {
  New = 'NEW',
  Captured = 'CAPTURED',
  Cancelled = 'CANCELLED',
  Notfound = 'NOTFOUND',
  Refund = 'REFUND'
}
